import React from "react";
import img1 from '../components/images/Mobile/mob1.png'
import img2 from '../components/images/Mobile/mob2.png'
import img3 from '../components/images/Mobile/mob3.png'
import img4 from '../components/images/Mobile/mob4.png'
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

function Mobiletheft() {
  const products = [
    {
      id: 1,
      image: img2,
      title: "RS 001",
      description: "Recoiler stand with retractable 3.2mm steel wire. Lockdown function at both sides. Locked charging cable. Under table screw mount option.",
      link: "/Productshowcase"
    },
    {
      id: 2,
      image: img3,
      title: "MS-Vertical-001",
      description: "White (Black can be customized)\nAlarm Volume: 100db\nSupport tablet, Earphone, cellphone",
      link: "/Productshowcase"
    },
    {
      id: 3,
      image: img4,
      title: "MS 004 - 1 High security",
      description: "2 adjustable metal brackets for cellphone (Size: 65-120mm)",
      link: "/Productshowcase"
    },
    {
      id: 4,
      image: img4,
      title: "RS 001-1 High security stand",
      description: "Recoiler stand with 2 adjustable metal brackets",
      link: "/Productshowcase"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Content Column */}
            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                ELECTRONIC DISPLAY SECURITY SYSTEM
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                Scalable security display solutions ranging from standard to high security 
                that let customers engage with devices and accessories.
              </p>
              <Link to="/quote" className="inline-block">
                <button className="bg-gradient-to-r from-emerald-600 to-teal-700 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:from-emerald-700 hover:to-teal-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5">
                  Request a Quote
                </button>
              </Link>
            </div>

            {/* Image Column */}
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src={img1}
                  alt="Phone and tablet security display" 
                  className="w-full h-auto object-cover"
                />
              </div>
              {/* Decorative gradient background */}
              <div className="absolute -z-10 top-8 right-8 w-full h-full bg-gradient-to-r from-emerald-600 to-teal-700 rounded-2xl opacity-20"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4 max-w-7xl">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-12">
            Phones
          </h2>
          
          <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8 mt-12">
            {products.map((product) => (
              <div 
                key={product.id} 
                className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group"
              >
                {/* Image Container */}
                <div className="h-64 flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 p-6">
                  <img 
                    src={product.image}
                    alt={product.title}
                    className="max-h-full w-auto object-contain group-hover:scale-105 transition-transform duration-300"
                  />
                </div>

                {/* Content Container */}
                <div className="p-6 space-y-4">
                  <h3 className="text-xl font-bold text-gray-900 text-center">
                    {product.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed whitespace-pre-line min-h-[100px]">
                    {product.description}
                  </p>
                  
                  {/* View Technology Link */}
                  <Link 
                    to={product.link}
                    className="flex items-center gap-2 text-emerald-700 font-semibold hover:text-teal-700 transition-colors group/link"
                    >
                    
                    <span>View technology</span>
                    <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" />
                    </Link>
                    
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Mobiletheft;